import {calculateEntryMetrics, getRoundedCalculations} from "@client/calculations";
import {Flush} from "@client/components/Flush";
import {classNames, server} from "@reactivated";
import * as React from "react";

const styles = {
    macro: "recipe-macro whitespace-nowrap",
    extraMacro: "recipe-macro whitespace-nowrap hidden md:inline",
} as const;

interface Props {
    recipe: server.journal.nutrition.Recipe.output;
    useKilojoules: boolean;
}

export const RecipeSummary = ({recipe, useKilojoules}: Props) => {
    const calculations = getRoundedCalculations(
        calculateEntryMetrics({
            entry: recipe,
            quantity: recipe.quantity,
            unit: recipe.unit,
        }),
        useKilojoules,
    );

    return (
        <Flush>
            <div
                className={classNames(
                    "border-t border-gray-300 px-4 text-xs flex justify-between py-3 mt-4",
                )}
            >
                <div className={styles.macro}>{calculations.protein} g protein</div>
                <div className={styles.macro}>{calculations.carbs} g carbs</div>
                <div className={styles.macro}>{calculations.fat} g fat</div>
                <div className={styles.macro}>{calculations.fiber} g fiber</div>
                <div className={styles.extraMacro}>
                    {calculations.net_carbs} g net carbs
                </div>
                <div className={styles.macro}>
                    {calculations.calories} {useKilojoules ? "kj" : "cal"}
                </div>
            </div>
        </Flush>
    );
};
